<script lang="ts">
  export let onClick: () => void;
</script>

<button class="container" on:click={onClick}>
  <slot name="icon" />
</button>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #3f3f3fcc;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    pointer-events: all;
  }
</style>
